import React from "react";
import classNames from "classnames";
import styles from "@css/components/common/cms_abstract.module.scss";
import ReactMarkdown from "react-markdown";

interface ICmsAbstract {
  data: string;
  className?: string;
}

const CmsAbstract: React.FC<ICmsAbstract> = (props: ICmsAbstract) => {
  const { data, className } = props,
    classes = classNames(styles["cms-abstract"], className);

  return (
    <div className={classes}>
      <ReactMarkdown
        remarkPlugins={[]}
        components={{
          a: ({ node, ...props }: any) => <a target="_blank" rel="noopener noreferrer" {...props} />,
        }}
      >
        {data}
      </ReactMarkdown>
    </div>
  );
};

export default CmsAbstract;
